<template>
  <div class="bs-report">

    <div class="card mt-2">
      <div class="card-body">
        <h5 class="card-title">{{bssReport.lrrId}} - {{bssReport.name}}</h5>
        <h6 class="card-subtitle mb-2 text-muted">uptime: {{formatPercentage(bssReport.uptimePerc)}}</h6>
        <h6 class="card-subtitle mb-2 text-muted">total downtime: {{bssReport.totalDowntimeMin.toFixed(2)}} min(s)</h6>
        
        <div class="outageSection" v-if="orderedOutages.length > 0">
          <h6>outages recorded <span class="fw-bold">{{orderedOutages.length}}</span></h6>

          <div class="row mb-2" v-for="outage in orderedOutages" :key="`${outage.startTs}-${outage.endTs}`">
            <div class="col-md"><em>from</em> <span class="fw-bold">{{formatTimestamp(outage.startTs, 'LLLL')}}</span></div>
            <div class="col-md"><em>to</em> <span class="ms-1 fw-bold">{{formatTimestamp(outage.endTs, 'LLLL')}}</span></div>
            <div class="col-md"><em>length</em> <span class="ms-1 fw-bold">{{outage.lengthMinutes?.toFixed(2) || 'N/A'}} min(s)</span></div>
          </div>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { BssUptimeReport } from '@/types'
import * as FilterUtil from '@/util/FilterUtil'

interface Props {
  bssReport: BssUptimeReport
}

const props = withDefaults(defineProps<Props>(), {
  bssReport: () => ({} as BssUptimeReport)
})

const formatPercentage = (value: number) => FilterUtil.percentage(value)
const formatTimestamp = (ts: number, format?: string) => FilterUtil.tsToString(ts, format)

const orderedOutages = computed(() => {
  if (!props.bssReport.outageList || props.bssReport.outageList.length === 0)
    return []

  return [...props.bssReport.outageList].sort((a, b) => a.startTs - b.startTs)
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.bs-report { 
  margin-left: auto;
  margin-right: auto;
}

.card {
  font-size: 0.8rem;
}

.card h5 {
  font-size: 1.25em;
  font-weight: bold;
}

.outageSection {
  color:#999;
}
</style>
